(() => {
  const money = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
  };

  const initSection = (section) => {
    if (!section || section.dataset.hfuiInitialized === 'true') return;
    section.dataset.hfuiInitialized = 'true';

    const variantsNode = section.querySelector('[data-hfui-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const variantInput = section.querySelector('[data-hfui-variant-id]');
    const price = section.querySelector('[data-hfui-price]');
    const submit = section.querySelector('[data-hfui-submit]');

    section.addEventListener('change', (event) => {
      if (!event.target.matches('[data-hfui-option]')) return;
      const selected = [...section.querySelectorAll('[data-hfui-option-group]')].map((group) => {
        const checked = group.querySelector('[data-hfui-option]:checked');
        return checked ? checked.value : null;
      });
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    });

    section.addEventListener('click', (event) => {
      const quantity = section.querySelector('[data-hfui-quantity]');
      if (event.target.closest('[data-hfui-quantity-minus]') && quantity) {
        quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      }
      if (event.target.closest('[data-hfui-quantity-plus]') && quantity) {
        quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
      }

      const trigger = event.target.closest('[data-hfui-image-trigger]');
      const lightbox = section.querySelector('[data-hfui-lightbox]');
      if (trigger && lightbox && typeof lightbox.showModal === 'function') {
        const image = lightbox.querySelector('[data-hfui-lightbox-image]');
        image.src = trigger.dataset.imageSrc || '';
        image.alt = trigger.querySelector('img')?.alt || '';
        lightbox.showModal();
      }

      if (event.target.closest('[data-hfui-lightbox-close]') && lightbox) lightbox.close();
    });
  };

  const initAll = (root = document) => root.querySelectorAll('[data-hfui-section]').forEach(initSection);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
